import "./index.css";
import React, { useEffect, useRef, useState } from "react";
import clsx from "clsx";
import styles from "./style.module.css";
import uuid from "uuid-random";
import IconProvider from "../../design-system/lib/IconProvider";
import { arrowTop, ic_circle_close } from "../../assets";
import Typography from "../../design-system/lib/Typography";
import { isEmpty } from "lodash";

// Hook برای بستن روی کلیک بیرون
const useClickOutside = (handler) => {
  const ref = useRef();
  useEffect(() => {
    const listener = (e) => {
      if (!ref.current || ref.current.contains(e.target)) return;
      handler(e);
    };
    document.addEventListener("mousedown", listener);
    return () => document.removeEventListener("mousedown", listener);
  }, [handler]);
  return ref;
};

// تبدیل config به props مناسب input
const getInputPropsFromConfig = (config) => {
  if (!config) return {};

  switch (config?.type) {
    case "number":
      return {
        type: "number",
        inputMode: "numeric",
        pattern: "[0-9]*",
        min: config.min,
        max: config.max,
        step: "1",
      };

    case "singleLine":
      return {
        type: "text",
        minLength: config.minLength,
        maxLength: config.maxLength,
      };

    case "email":
      return {
        type: "email",
      };

    case "decimalNumber":
      return {
        type: "text",
        inputMode: "decimal",
        pattern: `^\\d+(\\.\\d{0,${config.precision}})?$`,
        "data-precision": config.precision,
        min: config.min,
        max: config.max,
      };

    default:
      return {};
  }
};

const CustomField_Input = ({
  IconComponents,
  config,
  pretitle,
  handleIsOpen,
  hint,
  closeIcon,
  noArrowIcon = false,
  inputType,
  onChange,
  clearOnClick,
  data,
  text,
  badgeText,
  style,
  className,
  icon,
  isSelected,
  isRequired,
  textStyle,
  defvalue,
  containerStyle ,
  error
}) => {

  const [isOpen, setIsOpen] = useState(false);
  const [focus, setFocus] = useState(false);

  // ⭐ مقدار ورودی داخل کامپوننت
  const [value, setValue] = useState(defvalue || "");

  const [elmId] = useState(`elmDrop_${uuid()}`);
  const dropdownNode = useClickOutside(() => setIsOpen(false));

  const inputProps = config ? getInputPropsFromConfig(config) : { type: inputType };

  // ⭐ کنترل مقدار ورودی و validate
  const handleControlledChange = (rawValue) => {
    let result = rawValue;
    const logError = (msg) => console.error(`[CustomField_Input Error] ${msg}`);

    switch (config?.type) {
      case "number": {
        if (!/^\d*$/.test(rawValue)) {
          logError("Invalid number: only digits allowed");
          return;
        }
        result = rawValue;
        break;
      }

      case "decimalNumber": {
        const precision = config.precision ?? 2;
        const regex = new RegExp(`^\\d*(?:\\.\\d{0,${precision}})?$`);
        if (!regex.test(rawValue)) {
          logError(`Invalid decimal number`);
          return;
        }
        result = rawValue;
        break;
      }

      case "singleLine": {
        if (rawValue.includes("\n")) {
          logError("Single line input: newline not allowed");
          return;
        }
        result = rawValue;
        break;
      }

          case "multiLine": {
        if (rawValue.includes("\n")) {
          logError("Single line input: newline not allowed");
          return;
        }
        result = rawValue;
        break;
      }

       

      case "email": {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (rawValue !== "" && !emailRegex.test(rawValue)) {
          logError("Invalid email format");
        }
        result = rawValue;
        break;
      }

      default:
        result = rawValue;
    }

    // ⭐ مقدار را در state نگه می‌داریم
    setValue(result);

    // اگر پدر نیاز داشت مقدار را بگیرد
    onChange && onChange(result);
  };

  useEffect(() => {
    try {
      handleIsOpen && handleIsOpen(isOpen);
    } catch {}
  }, [isOpen]);


    useEffect(() => {
     if(!defvalue || isEmpty(defvalue)){
      setValue(defvalue || "")
     }
  }, [defvalue]);

  return (
    <div className={clsx(styles.containerStyle )} style={containerStyle && containerStyle}> 
    <div
      id={elmId}
      ref={dropdownNode}
      onClick={() => setIsOpen(!isOpen)}
      className={clsx(styles.tiny, className, focus && styles.focus)}
      style={style || {}}
    >
      {IconComponents && IconComponents}

      {icon && <IconProvider Icon={icon} size="14" />}

      <input
        {...inputProps}
        placeholder={hint}
        value={value}                                // ⭐ مقدار کنترل‌شده
        onChange={(e) => {handleControlledChange(e.target.value) ; setFocus(true)}}
        className={styles.input}
        style={{width:"100%"}}
         onFocus={() => { setFocus(true) }} onBlur={() => { setFocus(false) }} 
          onClick={() => { setFocus(true) }} 
      />

      {(text && pretitle) && (
        <span className={clsx(styles.title, textStyle)}>
          {closeIcon && isSelected && (
            <IconProvider
              Icon={ic_circle_close}
              size="14"
              onClick={(e) => {
                e.stopPropagation();
                setValue("");                        // ⭐ پاک شدن مقدار ورودی
                clearOnClick && clearOnClick();
              }}
            />
          )}

          {pretitle && (
            <>
              <span style={{ fontWeight: "400", color: "rgba(72,72,72,1)", marginInlineEnd: "-3px" }}>
                {pretitle} |
              </span>
              {text}
            </>
          )}

          {isRequired && !isSelected && <span className={styles.isRequired}> * </span>}
          {badgeText && <span className={styles.isRequired}> {badgeText} </span>}
        </span>
      )}

      {data && data.length > 0 && !noArrowIcon && (
        <IconProvider Icon={arrowTop} size="14" style={{ width: 14, height: 14,transform:"rotate(180deg)" }} />
      )}
    </div> 
    
    { error && <span className={styles.error}> {error} </span>}
    
      </div>
  );
};

export default CustomField_Input;
